<template>
    <div>
        <Spin fix v-show="isSpinShow" size="large" />
        <!--img :src="imgBarCode" style="width:80%"/>
        <form id="sform" method="post" name="sform" enctype="multipart/form-data">
            <p>
                <span style="font-size: 14px;"><label id="scan_code">条码：</label></span>
                <span><input class="infoInput"
                    id="result" style="width: 120px;" type="text" placeholder="" readonly="readonly" /></span>
                <input type="button" class="upload-btn" value="扫码" onclick="$('#code').click();" />
                <input id="code" class="pad10 b-f" style="display: none;" 
                    type="file" accept="image/*" @change="onClickInputFile"/>
                <img id="img" src="" />
            </p>
        </form-->
        <Button type="primary" @click="wechatScan">扫描</Button>
    </div>
</template>

<script>
    import Quagga from 'quagga';
    export default {
        mounted() {},
        data() {
            return {
                isSpinShow: false,
                imgBarCode: require("../../assets/imgs/barCode.gif"),
            }
        },
        methods: {
            wechatScan() {
                var that = this;
                that.isSpinShow = true;
                var thisUrl = encodeURIComponent(location.href);
                $.ajax({
                    url: "/api/getJsapiConfig?thisUrl=" + thisUrl,
                    contentType: "application/json",
                    type: "get",
                    async: true,
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.body == null) {
                            return;
                        }
                        wx.config({
                            debug: true, // 开启调试模式，关闭
                            appId: receiveData.body.appId, // 必填，公众号的唯一标识
                            timestamp: receiveData.body.timestamp, // 必填，生成签名的时间戳
                            nonceStr: receiveData.body.nonceStr, // 必填，生成签名的随机串
                            signature: receiveData.body.signature, // 必填，签名
                            jsApiList: ["scanQRCode"] // 需要使用的jsapi列表
                        });
                        wx.ready(function() {
                            wx.checkJsApi({
                                jsApiList: ["scanQRCode"],
                                success: function(res) {
                                    wx.scanQRCode({
                                        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                                        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                                        success: function(res) {
                                            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                                            alert(result);
                                        }
                                    });
                                }
                            });
                        });
                        console.log(receiveData);
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(XMLHttpRequest, textStatus) {
                        that.isSpinShow = false;
                    }
                });
            },
            onClickInputFile(param) {
                let that = this;
                that.isSpinShow = true;
                if (param.target.files) {
                    // 压缩文件
                    lrz(param.target.files[0])
                        .then(function(rst) {
                            console.log(rst);
                            that.imgBarCode = rst.base64;
                            that.scanBarCode(rst.base64);
                        }).catch(function(error) {
                            //失败时执行
                        }).always(function() {
                            //不管成功或失败，都会执行
                        })
                };
            },
            scanBarCode(base64) {
                let that = this;
                console.log(base64);
                Quagga.decodeSingle({
                    //解码方式，与条形码的编码方式有关
                    decoder: {
                        readers: ["code_128_reader"]
                    },
                    numOfWorkers: 0,
                    locate: true, // try to locate the barcode in the image
                    src: base64 // or 'data:image/jpg;base64,' + data
                }, function(result) {
                    that.isSpinShow = false;
                    console.log(result);
                    if (result) {
                        if (result.codeResult) {
                            $("#result").val(result.codeResult.code);
                        } else {
                            alert("条码格式错误，请使用Code128条码！");
                            $("#result").val("");
                        }
                    } else {
                        alert("未扫码成功，请重新扫码!");
                        $("#result").val("");
                    }
                });
            }
        }
    }
</script>

<style>
</style>
